// extracted by mini-css-extract-plugin
export var footer = "_nz-5";
export var fulfillmentInput = "_nz-0";
export var shipDateInput = "_nz-1";
export var shipmentModal = "_nz-2";
export var shipmentModalContent = "_nz-3";
export var tableContainer = "_nz-4";